import { useState } from "react";

/**
 * Soft nudge shown below the name field when a List/Template/Checklist has no
 * description (D-A6) — this is what lets the AI understand what a resource is for.
 * Dismissible, non-blocking, no API call.
 */
export function DescriptionHint({ show }: { show: boolean }) {
  const [dismissed, setDismissed] = useState(false);
  if (!show || dismissed) return null;
  return (
    <div className="mt-2 flex items-start justify-between gap-2 rounded-lg border border-brand-200 bg-brand-50/60 px-3 py-2 text-xs text-brand-800">
      <p>Add a description so AI suggestions understand what this list is for.</p>
      <button
        type="button"
        className="inline-flex min-h-6 min-w-6 shrink-0 items-center justify-center font-medium text-brand-700 hover:underline"
        aria-label="Dismiss hint"
        onClick={() => setDismissed(true)}
      >
        Dismiss
      </button>
    </div>
  );
}
